module.exports = __webpack_public_path__ + "img/magazine04.651b89f2.jpg";